"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fontana-liri": {
    "1fc1acfa": [{
      "hkey": "d6cec7e6",
      "slug": "collefontana-fontana-liri-inferiore",
      "name": "Collefontana-Fontana Liri Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "fontana-liri-inferiore": [{
      "hkey": "d6cec7e6",
      "slug": "collefontana-fontana-liri-inferiore",
      "name": "Collefontana-Fontana Liri Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;